import React, { useState } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Card, Button, Typography, Space, Checkbox, Input, Select, Divider } from 'antd';
import { MenuOutlined, DeleteOutlined, EditOutlined, SaveOutlined, CloseOutlined } from '@ant-design/icons';

const { Text } = Typography;
const { Option } = Select;

const MenuItem = ({ id, item, allItems, removeItem, updateItem }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editValues, setEditValues] = useState({
    title: item.title,
    url: item.url,
    parent: item.parent,
    is_mega_menu: item.is_mega_menu
  });

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    marginBottom: 8,
    marginLeft: (item.level || 0) * 30, // Indentation based on level
    zIndex: isDragging ? 10 : 1,
    opacity: isDragging ? 0.5 : 1,
    cursor: 'default'
  };

  const handleSave = async () => {
    await updateItem(id, editValues);
    setIsEditing(false);
  };

  const parentOptions = allItems.filter(i => i.id !== id);

  return (
    <div ref={setNodeRef} style={style}>
      <Card 
        size="small" 
        style={{ width: '100%', border: '1px solid #d9d9d9', borderRadius: 4 }}
        bodyStyle={{ padding: '8px 12px' }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Space>
            <div {...attributes} {...listeners} style={{ cursor: 'grab', display: 'flex' }}>
              <MenuOutlined style={{ color: '#bfbfbf' }} />
            </div>
            <Text strong>{item.title}</Text>
            {item.is_mega_menu && <Text type="danger" style={{ fontSize: 10 }}>[MEGA]</Text>}
            <Text type="secondary" style={{ fontSize: 11 }}>({item.item_type})</Text>
          </Space>
          
          <Space>
            <Text type="secondary" style={{ fontSize: 12 }}>{item.url}</Text>
            <Button 
              type="text" 
              icon={isEditing ? <CloseOutlined /> : <EditOutlined />} 
              onClick={() => setIsEditing(!isEditing)}
              size="small"
            />
            {!isEditing && (
              <Button 
                type="text" 
                danger 
                icon={<DeleteOutlined />} 
                onClick={() => removeItem(id)}
                size="small"
              />
            )}
          </Space>
        </div>

        {isEditing && (
          <div style={{ marginTop: 12, padding: 12, backgroundColor: '#fafafa', border: '1px solid #f0f0f0' }}>
            <div style={{ marginBottom: 8 }}>
              <Text type="secondary" style={{ fontSize: 12 }}>Navigation Label</Text>
              <Input 
                size="small" 
                value={editValues.title} 
                onChange={e => setEditValues({ ...editValues, title: e.target.value })} 
              />
            </div>
            <div style={{ marginBottom: 8 }}>
              <Text type="secondary" style={{ fontSize: 12 }}>URL</Text>
              <Input 
                size="small" 
                value={editValues.url} 
                onChange={e => setEditValues({ ...editValues, url: e.target.value })} 
              />
            </div>
            <div style={{ display: 'flex', gap: 16, marginBottom: 8 }}>
              <div style={{ flex: 1 }}>
                <Text type="secondary" style={{ fontSize: 12 }}>Parent Item</Text>
                <Select 
                  size="small" 
                  style={{ width: '100%' }} 
                  value={editValues.parent}
                  onChange={val => setEditValues({ ...editValues, parent: val })}
                  allowClear
                >
                  {parentOptions.map(p => (
                    <Option key={p.id} value={p.id}>{p.title}</Option>
                  ))}
                </Select>
              </div>
              <div style={{ marginTop: 24 }}>
                <Checkbox 
                  checked={editValues.is_mega_menu} 
                  onChange={e => setEditValues({ ...editValues, is_mega_menu: e.target.checked })}
                >
                  Mega Menu
                </Checkbox>
              </div>
            </div>
            <Divider style={{ margin: '8px 0' }} />
            <Button type="primary" size="small" icon={<SaveOutlined />} onClick={handleSave}>
              Save and Close
            </Button>
          </div>
        )}
      </Card>
    </div>
  );
};

export default MenuItem;
